import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "error"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "404エラー", -1);
const _hoisted_5 = { class: "err_box" };
const _hoisted_6 = { class: "lead" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "ページが見つかりません", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode("指定されたページは、削除されたか、"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createTextVNode("他の場所に移動した可能性があります。")
], -1);
const _hoisted_9 = { class: "bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'error',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(ImageFrame, { src: "images/common/404error.svg" }),
                                    _hoisted_7,
                                    _hoisted_8
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    (props.common.role)
                                        ? (_openBlock(), _createBlock(_unref(Link), {
                                            key: 0,
                                            href: "/question",
                                            class: "bt_home"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("ホームに戻る")
                                            ]),
                                            _: 1
                                        }))
                                        : (_openBlock(), _createBlock(_unref(Link), {
                                            key: 1,
                                            href: "/",
                                            class: "bt_home"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("戻る")
                                            ]),
                                            _: 1
                                        }))
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ], 64));
        };
    }
});
